import { Component, TemplateRef, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { OfferInputModel } from '../../shared/models/OfferInputModel';
import { ToastService } from '../../shared/providers/toast.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../../shared/providers/offer.service';
import { PropertyDetailForOffer } from '../../shared/models/PropertyDetailForOffer';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { AuthService } from '../../shared/auth/auth.service';
import { IFileUpload } from '../../shared/models/fileupload';
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { ValidationService } from '../../shared/providers/validation.service';
//import { ScrollToService } from 'ng2-scroll-to-el';
import { NumberToWordsPipe } from '../../shared/pipes/number-to-words.pipe';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { RestService } from '../../shared/providers/rest.service';
import { CommonService } from '../../shared/providers/common.service';
import { DuplicateEmailCheckInputModel } from '../../shared/models/DuplicateEmailCheckInputModel';
import 'rxjs';
import { MultipleEmailIdModel } from '../../shared/models/MultipleEmailIdModel';
import { ExchangeCodeInputModel } from '../../shared/models/ExchangeCodeInputModel';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { PropertyDocument } from '../../shared/models/SavePropertyInputModel';
import { PrincipalEmailInputModel } from '../../shared/models/PrincipalEmailInputModel';
interface Iexchange {
  userId: number,
  exId: number,
  email: string,
  company: string,
  phone: string,
  buyer: string,
  firstName: string,
  lastName: string
}

interface IMatchingUsers {
  UserId: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Company: string;
  ProfilePic: string;
}

@Component({
  selector: 'place-offer',
  templateUrl: './offer.component.html',
})

export class OfferComponent {
  @Input() inputPropertyGuid: string = "";
  @Input() inputOfferGuid: string = "";
  @Input() IsFromPropertyView: boolean;
  @Input() propType: number = 601;
  @Input() isPortfolio: boolean = false;
  fileTypes = '.PDF, .DOCX, .DOC';
  allFileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  @Input() propertyList: any = [];
  @Input() inputPropertyId: number;
  @Input() askingPrice: number;
  @Input() fromOfferMatrix: boolean = false;
  @Input() isFromQuickEdit: boolean = false;
  @Output() close = new EventEmitter();
  modalRefSendEmail: BsModalRef;
  @ViewChild('sendPrincipleEmail') sendEmail: TemplateRef<any>;

  @Output() showPortfolioData = new EventEmitter();
  haveaccesstoviewlocation: boolean = true;
  IsValid: boolean = false;
  firstNameValid: boolean = false;
  lastNameValid: boolean = false;
  emailValid: boolean = false;
  emailvalidation: string = "";
  phoneValidation: string = "";
  phoneValid: boolean = false;
  buyerPowerValid: boolean = false;
  assetValueValid: boolean = false;
  offerPriceValid: boolean = false;
  earnestMoneyDepositValid: boolean = false;
  dueDiligencePeriodValid: boolean = false;
  closingPeriodValid: boolean = false;
  wizard = 0;
  selectExchange: string;
  isSaveDisabled: boolean = false;
  ishavepermission: boolean = false;
  user: any;
  message = null;
  propertyGuid: string = "";
  @Input() LivePropertyGuid: string = '';
  BuyerQuestionsOfferId: number = 0;
  BuyerQuestionsPropertyId: number = 0;
  offerInputModel = {} as OfferInputModel;
  offerResponseModel: OfferInputModel;
  principalEmailInputModel = {} as PrincipalEmailInputModel;
  propertyDetailForOffer = {} as PropertyDetailForOffer;
  resultOutputModel = {} as ResultOutputModel;
  inputFileUpload = {} as IFileUpload;
  inputFileUploadAdditional = {} as IFileUpload;
  inputFileUploadForLOI = {} as IFileUpload;
  exchangeCodes: IExchangeCodeOutputModel[];
  exchangeCodeInputModel = {} as ExchangeCodeInputModel;
  duplicateEmailCheckInputModel = {} as DuplicateEmailCheckInputModel;
  selectedFiles: string[] = [];
  selectedFilesForLOI: string[] = [];
  selectedFilesForAdditional: string[] = [];
  categories: ILookUp[];
  errorMessage: string;
  errorMessageForLOI: string;
  fileExtensionType: string = "document";
  fileExtensionLOIType: string = "LOI";
  fileUploadType: string = "multiple";
  clearFiles: number = 0;
  clearFilesForLOI: number = 0;
  propertyId: number = 0;
  modalRef: BsModalRef;
  modalBuyerRef: BsModalRef;
  modalRefMatching: BsModalRef;
  modalRefShareWithOthers: BsModalRef;
  disableTextBox: string = "false";
  today: Date;
  exchangeClosingDate: string;
  IsSendEmailToBuyer: boolean = false;
  IsSeneEmailIsshowed: boolean = false;
  fromPage: string;
  isBrokerView: boolean = false;
  isNormalPrincipalView: boolean = false;
  dataService: [];/*CompleterData;*/
  isEdit: boolean = false;
  isExchangeDisabled: boolean = false;
  downloadLOIPath: string;
  mailIds: MultipleEmailIdModel[];
  keyCode: number[];
  disabledShareBtn: boolean = false;
  offerPriceValidText: string = "Offer price is required";
  earnestMoneyDepositValidText: string = "Earnest Money Deposit is required";
  dueDeligencePeriodValidText: string = "Due Deligence Period is required";
  closingPeriodValidText: string = "Closing Period is required";
  IsExternalBroker: boolean = false;
  showBuyerInfoForPrincipal: boolean = false;
  showPortfolio = false;
  data: any;
  placeOffer = false;
  disblesubmitofferbutton = false;
  submitLOIConfirmationMessage: string = "Our Broker will get in touch with you soon";
  matchingUsers: IMatchingUsers[];
  duplicateUserFound: boolean = false;
  showLinkto1031Exchange: boolean = true;
  @ViewChild('duplicateNameCheck') private content: TemplateRef<any>;
  @ViewChild('templateSubmit') private template: TemplateRef<any>;
  @ViewChild('MatchingUsers') MatchingUsersModal: TemplateRef<any>;
  docPreview: any;
  documentPreview: BsModalRef;
  constructor(private _offerService: OfferService, public validationService: ValidationService, private _toastService: ToastService, public _commonService: CommonService,
    private activatedRoute: ActivatedRoute, public authService: AuthenticationService, private modalService: BsModalService, private _restService: RestService,
    private router: Router, private _fileUploadService: FileUploadService, protected loaderService: LoaderService, /*private completerService: CompleterService,*/
    private trade1031Service: Trade1031Service, //private scrollService: ScrollToService
    private numToWord: NumberToWordsPipe,
    private _authService: AuthService) {

    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/common/principalListByAutoComplete/', 'Name', 'Name');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/common/principalListByAutoComplete/' + x);
    //});

    //this.dataService = remoteDataProvider;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {

      this.offerInputModel.UtmId = params['utm_id'];
      this.offerInputModel.UtmSource = params['utm_source'];
      this.offerInputModel.UtmMedium = params['utm_medium'];
      this.offerInputModel.UtmCampaign = params['utm_campaign'];
      this.offerInputModel.UtmTerm = params['utm_term'];
      this.offerInputModel.UtmContent = params['utm_content'];
    });

    if (this.fromOfferMatrix) {
      this.showWizard(1);
    }
    if (this.isPortfolio) {
      this.showPortfolio = true;
      this.showWizard(1);
    }
    else {
      this.showPortfolio = false;
    }
    //this.setUploadDefaultValues();
    this.user = this.authService.user;
    this.isExchangeDisabled = false;
    this.today = new Date();

    if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.Principal)) {
      this.isNormalPrincipalView = true;
    }
    this.selectExchange = "Select Exchange";
    if (this.user != null && (this.authService.IsUserRole(this.authService.UserRole.Broker))) {
      this.isBrokerView = true;
      this.offerInputModel.CoBrokerId = this.user.Id;
      this.offerInputModel.CoBrokerFirstName = this.user.FirstName;
      this.offerInputModel.CoBrokerLastName = this.user.LastName;
      this.offerInputModel.CoBrokerEmail = this.user.UserName;
      this.offerInputModel.CoBrokerPhone = this.user.PhoneNumber;
      this.exchangeCodeInputModel.AssignedAgentId = this.user.Id;
      this.exchangeCodeInputModel.IsBrokerView = true;
      this.offerInputModel.IsSendMail = true;
    }
    else if (this.user != null && (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))) {
      this.isBrokerView = true;
      this.offerInputModel.CoBrokerId = this.user.Id;
      this.offerInputModel.CoBrokerFirstName = this.user.FirstName;
      this.offerInputModel.CoBrokerLastName = this.user.LastName;
      this.offerInputModel.CoBrokerEmail = this.user.UserName;
      this.offerInputModel.CoBrokerPhone = this.user.PhoneNumber;
      this.exchangeCodeInputModel.AssignedAgentId = this.user.Id;
      this.exchangeCodeInputModel.IsBrokerView = true;
      this.offerInputModel.IsSendMail = true;
    }
    else {
      if (this.user !== null && this.user.Guid != undefined && !this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        if (!this.authService.IsUserRole(this.authService.UserRole.Admin) && !this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
          this.offerInputModel.IsSendMail = true;
          this.offerInputModel.UserId = this.user.Id;
          this.offerInputModel.FirstName = this.user.FirstName;
          this.offerInputModel.LastName = this.user.LastName;
          this.offerInputModel.Email = this.user.UserName;
          this.offerInputModel.Phone = this.user.PhoneNumber;
          this.offerInputModel.CompanyName = this.user.CompanyName;
        }
        this.exchangeCodeInputModel.BuyerId = this.user.Id;
        this.exchangeCodeInputModel.IsBrokerView = false;
      }
    }

    if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
      this.IsExternalBroker = true;
      this.isBrokerView = true;
      this.offerInputModel.CoBrokerId = this.user.Id;
      this.offerInputModel.CoBrokerFirstName = this.user.FirstName;
      this.offerInputModel.CoBrokerLastName = this.user.LastName;
      this.offerInputModel.CoBrokerEmail = this.user.UserName;
      this.offerInputModel.CoBrokerPhone = this.user.PhoneNumber;
    }

    if (this.user != null && (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031))) {
      this.showBuyerInfoForPrincipal = true;
    }

    //if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.Admin)) {
    //  this.offerInputModel.UserId = this.user.Id;
    //}

    this.offerInputModel.Exchange1031Id = 0;
    this.offerInputModel.ExchangeAmount = null;
    this.offerInputModel.ExchangeClosingDate = null;

    // Loads the property categories
    this._commonService.getLookupsByTypeId(7).subscribe(response => {
      this.categories = response.filter(x => x.Id >= 413).map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
    });
    if (this.inputPropertyGuid == "" || this.inputPropertyGuid == null) {
      this.activatedRoute.params.subscribe(params => {
        this.propertyGuid = (this.LivePropertyGuid != null && this.LivePropertyGuid != undefined && this.LivePropertyGuid != '') ? this.LivePropertyGuid : params.id;
        this.inputOfferGuid = !this.isFromQuickEdit ? params.offerGuid : this.inputOfferGuid;
        if (params.fromPage !== null && params.fromPage !== undefined) {
          this.fromPage = params.fromPage;
          this.fromPage = this.fromPage.toString().replace("@@", "/");

        }
      });
    } else {
      this.propertyGuid = (this.LivePropertyGuid != null && this.LivePropertyGuid != undefined && this.LivePropertyGuid != '') ? this.LivePropertyGuid : this.inputPropertyGuid;
    }

    if (!this.validationService.IsinValid(this.inputOfferGuid) && this.inputOfferGuid != "" && this.inputOfferGuid != null && this.inputOfferGuid != '00000000-0000-0000-0000-000000000000') {
      this.isEdit = true;
    }

    if (this.propertyGuid != "") {
      this.getPropertyDetail();
      this.offerInputModel.PropertyGuid = this.propertyGuid;

    }

    if (!this.validationService.IsinValid(this.inputOfferGuid) && this.inputOfferGuid != "" && this.inputOfferGuid != null && this.inputOfferGuid != '00000000-0000-0000-0000-000000000000') {
      this.getOfferDetailForEdit();
    }

    if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
      this.offerInputModel.Is1031Exchange = true;
      this.isNormalPrincipalView = false;
      this.onIs1031ExchangeCheckboxChange(true);
    }
    else {
      this.offerInputModel.Is1031Exchange = false;
      this.onIs1031ExchangeCheckboxChange(false);
    }
    this.offerInputModel.SendInvitationMail = true;
    this.have1031ExchangeCheckboxChange(true)
  }
  //scrollToTop(element) {
  //    
  //    this.scrollService.scrollTo(element);

  //}

  onRemoveLOIDocument(i: any) {
    this.filesCollectionLOI.splice(i, 1);
    this.selectedFilesForLOI.splice(i, 1);
  }

  onRemoveAdditionalDocument(i: any) {
    this.filesCollectionAdditional.splice(i, 1);
  }
  onRemoveDocument(i: any) {
    this.filesCollection.splice(i, 1);
    this.selectedFiles.splice(i, 1);
  }
  scrollToTop(element, offset) {
    //this.scrollService.scrollTo(element, offset);
    $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
  }

  uploadFiles() {
    this.inputFileUpload.fileCategoryId = 414;
    this.inputFileUpload.id = this.latestId;
    this.inputFileUpload.objectId = this.latestId;
    this.inputFileUpload.objectTypeId = 303;
    this.inputFileUpload.documentName = "User Document";
    this.inputFileUpload.type = "Documents";
    this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
      this.clearFiles++;
    });
  }

  uploadFilesAdditional() {
    this.filesCollectionAdditional.forEach(item => {
      this.inputFileUploadAdditional.fileCategoryId = 414;
      this.inputFileUploadAdditional.id = this.latestId;
      this.inputFileUploadAdditional.objectId = this.latestId;
      this.inputFileUploadAdditional.objectTypeId = 303;
      this.inputFileUploadAdditional.documentName = "User Document";
      this.inputFileUploadAdditional.type = "Documents";
      let fileToUpload = [];
      fileToUpload.push(item["file"]);
      this._fileUploadService.uploadFiles(this.inputFileUploadAdditional, fileToUpload).subscribe(response => {
        this.clearFiles++;
      });
    });
  }
  latestId = 0;
  uploadedLOIPath = "";


  onKeydown(event, tab) {
    if (event.key === "Enter" && tab == 'tab1') {
      this.showWizard(2);
    }
    if (event.key === "Enter" && tab == 'tab2') {
      this.showWizard(3);
    }
  }
  filesCollection = [];
  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {

    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      const fileObj =
      {
        name: item["name"],
        category: 414,
        file: item
      }
      this.filesCollection.push(fileObj);
    });
  }

  filesCollectionAdditional = [];
  selectedFilesListEmitterAdditional(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFilesForAdditional = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFilesForAdditional.forEach(item => {
      const fileObj =
      {
        name: item["name"],
        category: 414,
        file: item
      }
      this.filesCollectionAdditional.push(fileObj);
    });
  }

  filesCollectionLOI = [];
  selectedFilesListEmitterForLOI(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFilesForLOI = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    if (this.filesCollectionLOI.length < 1) {
      this.selectedFilesForLOI.forEach(item => {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollectionLOI.push(fileObj);
      });
    }
    else {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Cannot upload multiple LOI documents', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }


  //getDocId(index: number): number {
  //    if (this.selectedFilesForLOI) {
  //        return this.selectedFilesForLOI[index].Id;
  //    }
  //}
  setUploadDefaultValues() {
    //Additional info
    this.inputFileUpload.fileCategoryId = 411;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 303;
    this.inputFileUpload.documentName = "User Document";
    this.inputFileUpload.type = "Documents";

    //LOI
    this.inputFileUploadForLOI.fileCategoryId = 408;
    this.inputFileUploadForLOI.id = 0;
    this.inputFileUploadForLOI.objectId = 0;
    this.inputFileUploadForLOI.objectTypeId = 303;
    this.inputFileUploadForLOI.documentName = "LOI Document";
    this.inputFileUploadForLOI.type = "Documents";
  }
  wizardData: any;
  showWizard(data: any) {
    this.IsValid = true;
    this.isOwnLOI = false;
    this.wizardData = data;

    if (data == 0) {
      var element = document.getElementById("divPlaceOfferChild");
      this.scrollToTop(element, 0);
      this.wizard = data;
    }
    if (data == 1) {
      var element = document.getElementById("divPlaceOfferChild");
      if (sessionStorage.getItem('PlaceOfferSource') != null && sessionStorage.getItem('PlaceOfferSource') != undefined) {
        this.scrollToTop(element, 1850);
        sessionStorage.removeItem('PlaceOfferSource');
      }
      else {
        this.scrollToTop(element, 0);
      }
      this.wizard = data;
      this.isOwnLOI = true;
      this.offerInputModel.IsGeneratedLOI = false;
      if (this.propType == 601 && !this.isEdit && !this.isFromQuickEdit && this.authService.Broker()) {
        this.offerInputModel.OfferForExtBroker = true;
      }
      else if (!this.isEdit) {
        this.offerInputModel.OfferForExtBroker = false;
      }

    }
    if (data == 11) {
      this.offerInputModel.IsGeneratedLOI = true;
      var element = document.getElementById("divPlaceOfferChild");
      this.scrollToTop(element, 0);
      this.wizard = data;

    }
    else if (data == 2) {
      var element = document.getElementById("divPlaceOfferChild");
      this.scrollToTop(element, 650);
      if (this.IsValid) {

        this.offerDetailsValidation();
      }
      if (this.IsValid) {
        this.wizard = data;

        if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

          this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
        }

      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }

    }
    else if (data == 3) {
      var element = document.getElementById("divPlaceOfferChild");
      this.scrollToTop(element, 600);

      this.offerDetailsValidation(this.isBrokerView ? 1 : 0);
      //if (this.isBrokerView && this.IsValid) {
      //    this.buyerInformationValidation();
      //}
      if (this.IsValid) {
        if ((this.offerInputModel.OfferForExtBroker && !this.extBrokerSelected)) {
          this.checkMatchingUsers();
        }
        else if (this.authService.Broker()) {
          this._offerService.checkDuplicatePrincipal(this.offerInputModel).subscribe(response => {
            if (response != null) {
              this.IsValid = false;
              this.data = data;
              var msg = 'The ' + response + ' is not matching with data existing in the system. Would you like to proceed?';
              this.openDuplicateModal(this.content, '', msg);
            }
            else {
              this.showDataWizard3(data);
            }
          });

        }
        else {
          this.showDataWizard3(data);
        }
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
  }

  showDataWizard3(data) {
    if (this.propertyDetailForOffer.PrimaryContactName != null) {
      this.submitLOIConfirmationMessage = this.propertyDetailForOffer.PrimaryContactName + " will get in touch with you soon";
    }
    else {
      this.submitLOIConfirmationMessage = "Our Broker will get in touch with you soon";
    }
    this.offerInputModel.OwnLOI = true;
    this.offerInputModel.PriceToWords = !this.propertyDetailForOffer.Unpriced ? this.numToWord.transform(this.propertyDetailForOffer.Price, null) : 'Unpriced';
    this.offerInputModel.OfferPriceToWords = this.numToWord.transform(this.offerInputModel.OfferPrice, null);
    this.offerInputModel.EarnestMoneyDepositToWords = this.numToWord.transform(this.offerInputModel.EarnestMoneyDeposit, null);
    this.offerInputModel.DueDiligencePeriodToWords = this.numToWord.transform(this.offerInputModel.DueDiligencePeriod, null);
    this.offerInputModel.ClosingPeriodToWords = this.numToWord.transform(this.offerInputModel.ClosingPeriod, null);
    if (this.offerInputModel.AssetValue != 0 && this.offerInputModel.AssetValue != undefined) {
      this.offerInputModel.AssetValueToWords = this.numToWord.transform(this.offerInputModel.AssetValue, null);
    }
    else {
      this.offerInputModel.AssetValueToWords = null;
    }
    if (this.offerInputModel.BuyerPower != 0 && this.offerInputModel.BuyerPower != undefined) {
      this.offerInputModel.BuyerPowerToWords = this.numToWord.transform(this.offerInputModel.BuyerPower, null);
    }
    else {
      this.offerInputModel.BuyerPowerToWords = null;
    }
    var element = document.getElementById("divPlaceOfferChild");
    this.scrollToTop(element, 600);
    if (this.isBrokerView) {
      this.buyerInformationValidation();
      if (this.IsValid) {
        this.duplicateEmailCheckInputModel.Email = this.offerInputModel.Email;
        this.offerInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
        if (!this.isEdit) {
          if (this.offerInputModel.UserId != 0) {
            this._offerService.checkDuplicatePlaceOfferByCoBroker(this.offerInputModel).subscribe(response => {
              if (response) {
                this._toastService.addToast({ title: 'Error Occurred', msg: 'Sorry! You cannot submit an offer against this property because, either you or a user associated with you has already submitted an offer and is still under sellers consideration.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              }
              else {
                var element = document.getElementById("divPlaceOfferChild");
                this.scrollToTop(element, 600);
                this.wizard = data;
                if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {
                  this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
                }
              }
            });
          }
          else {
            if (!this.offerInputModel.OfferForExtBroker) {
              //this._commonService.checkDuplicateEmail(this.duplicateEmailCheckInputModel).subscribe(response => {
              //if (response) {
              //    this._toastService.addToast({ title: 'Error Occurred', msg: 'User with same email address already registered', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              //}
              //else {

              var element = document.getElementById("divPlaceOfferChild");
              this.scrollToTop(element, 600);
              this.wizard = data;
              if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

                this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
              }
              //    }
              //});
            }
            else {
              var element = document.getElementById("divPlaceOfferChild");
              this.scrollToTop(element, 790);
              this.wizard = data;
              if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

                this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
              }
            }
          }
        }
        else {
          var element = document.getElementById("divPlaceOfferChild");
          this.scrollToTop(element, 790);
          this.wizard = data;
          if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

            this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
          }
        }

      } else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this.wizard = data;
      if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

        this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
      }
    }
  }

  checkMatchingUsers(template?: TemplateRef<any>, classes?: any) {
    this._offerService.PlaceOfferMatchingUser(this.offerInputModel).subscribe(response => {
      this.loaderService.display(false);
      this.matchingUsers = response;
      if (this.matchingUsers.length > 0) {
        this.modalRefMatching = this.modalService.show(this.MatchingUsersModal, { class: 'deletemodal' });
      }
      else {
        if (!this.isOwnLOI) {
          this.showDataWizard3(this.wizardData);
        }
        else {
          this.checkExistingUser();
          this.modalRef = this.modalService.show(template, { class: classes });
        }
      }
    });
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  onBuyerInfoKeydown() {
    if (this.user.UserName == this.offerInputModel.Email && this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
      this.offerInputModel.Email = '';
      this._toastService.addToast({ title: 'Duplicate user', msg: 'The Buyer Email and loggedin email cannot be the same', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }

    this.buyerInformationValidation();
  }
  openBrokerModal(template: TemplateRef<any>, classes: any) {

    this.modalRef = this.modalService.show(template, { class: classes });
    this.propertyId = this.propertyDetailForOffer.PropertyId;;
  }
  openModal(template: TemplateRef<any>, classes: any, text: any, validate = false, isCancel = false) {
    this.checkExistingUser();
    if (this.isFromQuickEdit) {
      this.disblesubmitofferbutton = true;
    }
    if (text == 'LOI') {
      if (!validate || (validate && !this.isPortfolio) || (this.isPortfolio)) {
        this.offerInputModel.OwnLOI = false;
        //if (this.isBrokerView) {
        //    this.buyerInformationValidation();
        //}
        this.offerDetailsValidation(this.isBrokerView ? 1 : 0);
        if (this.IsValid) {
          if (this.selectedFilesForLOI.length == 0) {
            this.scroll(600);
            this.disblesubmitofferbutton = false;
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please upload an LOI document', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
          else if (this.isBrokerView) {
            this._offerService.checkDuplicatePrincipal(this.offerInputModel).subscribe(response => {
              if (response != null) {
                this.placeOffer = true;
                this.disblesubmitofferbutton = false;
                var msg = 'The ' + response + ' is not matching with data existing in the system.Would you like to proceed ?';
                this.openDuplicateModal(this.content, '', msg);
              }
              else {
                this.placeOffer = true;
                if ((this.offerInputModel.OfferForExtBroker && !this.extBrokerSelected)) {
                  this.checkMatchingUsers(template, classes);
                }
                else {
                  this.modalRef = this.modalService.show(template, { class: classes });
                }
              }
            });

          }
          else {
            this.placeOffer = true;
            if ((this.offerInputModel.OfferForExtBroker && !this.extBrokerSelected)) {
              this.checkMatchingUsers(template, classes);
            }
            else {

              this.modalRef = this.modalService.show(template, { class: classes });
            }
          }
        }
        else {
          this.scroll(600);
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {

      this.modalRef = this.modalService.show(template, { class: classes });
    }
  }

  openDuplicateModal(template: TemplateRef<any>, classes: any, text: any) {
    this.message = text;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  goNext() {
    this.modalRef.hide();
    this.offerInputModel.IsUseBuyerDetail = true;
    if (!this.placeOffer) {
      this.showDataWizard3(this.data);

    }
    else {
      this.openModal(this.template, '', '', false);
    }
  }

  scroll(offset) {
    var element = document.getElementById("divPlaceOfferChild");
    this.scrollToTop(element, offset);
  }

  onOfferContingentFinancingChange(event) {
    this.offerInputModel.LTV = null;
    this.offerInputModel.Term = null;
    this.offerInputModel.InterestRate = null;
    this.offerInputModel.Amortization = null;
  }

  clearUserData() {
    this.offerInputModel.UserId = 0;
    this.offerInputModel.FirstName = null;
    this.offerInputModel.LastName = null;
    this.offerInputModel.Email = null;
    this.offerInputModel.Phone = null;
    this.offerInputModel.CompanyName = null;
  }
  onIs1031ExchangeCheckboxChange(val) {
    this.extBrokerSelected = false;
    this.brokerSelectedFromSlider = false;
    if (val) {

      if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.Broker) && !this.isEdit) {
        this.clearUserData();
      }
      this.exchangeCodeInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
      this.exchangeCodeInputModel.IsEdit = (this.isFromQuickEdit || this.isEdit) ? true : false;
      this.trade1031Service.GetExchangeCodeByBuyerAndBroker(this.exchangeCodeInputModel).subscribe(res => {
        if (res.length > 0) {
          this.exchangeCodes = res.filter(x => x.ExchangeType != 2);
          ////this.offerInputModel.Exchange1031Id = res[0].Id;
          this.offerInputModel.Exchange1031Id = (this.offerInputModel.Exchange1031Id != null && this.offerInputModel.Exchange1031Id != 0) ? this.offerInputModel.Exchange1031Id : res[0].Id;
          this.exchangeCodes.forEach(item => {
            let ProjectedSaleDate = this.validationService.convertUTCDateToLocalDate(item.ProjectedSaleDate);
            item.ExchangeCode = item.ExchangeCode + " " + this.validationService.formatDatetoMMDDYYYY(ProjectedSaleDate);
            let SaleDateEnd = this.validationService.convertUTCDateToLocalDate(this.validationService.addDays(ProjectedSaleDate, 180));
            item.ExchangeCode = item.ExchangeCode + "-" + this.validationService.formatDatetoMMDDYYYY(SaleDateEnd);
          });
          this.checkIsConnectedExchange();
        }
        else {
          if (this.user != null && this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
            this.offerInputModel.Is1031Exchange = false;
          }
        }
      });
      this.offerInputModel.OfferForExtBroker = false;
      this.onExternalBrokerPlaceOffer();
    }
    else {
      this.offerInputModel.Exchange1031Id = 0;
      this.offerInputModel.ExchangeAmount = null;
      this.offerInputModel.ExchangeClosingDate = null;
      if (this.user != null && !this.isEdit && !this.authService.IsUserRole(this.authService.UserRole.Principal) && !this.authService.IsUserRole(this.authService.UserRole.Principal1031) && !this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) && !this.authService.IsUserRole(this.authService.UserRole.Admin) && !this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.ClearExchange();
      }
      ////this.offerInputModel.Name = null;
      ////this.offerInputModel.FirstName = null;
      ////this.offerInputModel.LastName = null;
      ////this.offerInputModel.Email = null;
      ////this.offerInputModel.Phone = '';
      ////this.offerInputModel.CompanyName = null;
    }
  }
  IsConnectedExchange = false;
  checkIsConnectedExchange() {

    let selectedEx = this.exchangeCodes.find(x => x.Id == this.offerInputModel.Exchange1031Id);
    if (selectedEx != null) {
      if (selectedEx.ExchangeType !== undefined) {
        if (selectedEx.ExchangeType == 2) {
          this.IsConnectedExchange = true;
        }
        else {
          this.IsConnectedExchange = false;
        }
      }
    }
  }
  have1031ExchangeCheckboxChange(val) {
    if (val) {
      if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
        this.exchangeCodeInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
        this.exchangeCodeInputModel.IsEdit = (this.isFromQuickEdit || this.isEdit) ? true : false;
        this.trade1031Service.GetExchangeCodeByBuyerAndBroker(this.exchangeCodeInputModel).subscribe(res => {
          if (res.length > 0) {
            this.showLinkto1031Exchange = true;
            this.checkIsConnectedExchange();
          }
          else {
            this.showLinkto1031Exchange = false;
          }
        });
      }
      else {
        this.showLinkto1031Exchange = true;
      }
    }
  }
  on1031ExchangeChange(item) {
    if (this.offerInputModel.Exchange1031Id == 0) {
      this.offerInputModel.ExchangeCode = null;
      this.offerInputModel.ExchangeAmount = null;
      this.offerInputModel.ExchangeClosingDate = null;
      this.IsConnectedExchange = false;
    }
    else {
      var data = this.exchangeCodes.find(x => x.Id == this.offerInputModel.Exchange1031Id);
      this.checkIsConnectedExchange();

      this.offerInputModel.ExchangeCode = data.ExchangeCode;
      this.offerInputModel.ExchangeAmount = this.validationService.commaFormat(data.SalePrice);
      //this.offerInputModel.ExchangeClosingDate = new Date(this.validationService.convertUTCDateToLocalDate(this.validationService.addDays(data.ProjectedSaleDate, 180)));
      this.offerInputModel.ExchangeClosingDate = this.validationService.convertUTCDateToLocalDate(data.ProjectedSaleDate);
    }
  }
  checkIfUserInfoValid() {
    if (this.validationService.IsinValid(this.offerInputModel.FirstName)) {
      this.firstNameValid = true;
      this.IsValid = false;
    }
    else {
      this.firstNameValid = false;
    }

    if (this.validationService.IsinValid(this.offerInputModel.LastName)) {
      this.lastNameValid = true;
      this.IsValid = false;
    }
    else {
      this.lastNameValid = false;
    }

    if (!this.IsExternalBroker) {
      if (this.validationService.IsinValid(this.offerInputModel.Email)) {
        this.emailValid = true;
        this.IsValid = false;
        this.emailvalidation = "";
      }
      else if ((this.validationService.isEmail(this.offerInputModel.Email) == false) && !this.validationService.IsinValid(this.offerInputModel.Email)) {
        this.emailValid = true;
        this.IsValid = false;
        this.emailvalidation = "invalid Email address";
      }
      else {
        this.emailValid = false;
        this.emailvalidation = "";
      }


      if (this.validationService.IsinValid(this.offerInputModel.Phone)) {
        this.phoneValid = true;
        this.IsValid = false;
        this.phoneValidation = "";

      }
      else if (this.validationService.isPhoneNumber(this.offerInputModel.Phone) == false) {
        this.phoneValidation = "Invalid phone number";
        this.phoneValid = true;
        this.IsValid = false;

      }
      else {
        this.phoneValidation = "";
        this.phoneValid = false;
      }
    }
    else {
      this.IsValid = true;
    }
  }
  checkIfUserAlreadyExists() {
    if ((this.validationService.isEmail(this.offerInputModel.Email) == true) && !this.validationService.IsinValid(this.offerInputModel.Email)) {
      this._offerService.checkDuplicatePrincipal(this.offerInputModel).subscribe(response => {
        if (response != null) {
          this.IsValid = false;
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Please check the ' + response + ' for the user', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else {
          this.IsValid = true;
        }
      });
    }


  }
  buyerInformationValidation() {
    this.IsValid = true;
    this.checkIfUserInfoValid();
  }

  offerDetailsValidation(type?: number) {
    this.IsValid = true;
    if (this.validationService.IsinValidPrice(this.offerInputModel.OfferPrice)) {
      this.offerPriceValid = true;
      this.IsValid = false;
    }
    else {
      this.offerPriceValid = false;
    }

    if (this.validationService.IsinValidPrice(this.offerInputModel.EarnestMoneyDeposit)) {
      this.earnestMoneyDepositValid = true;
      this.IsValid = false;
    }
    else {
      this.earnestMoneyDepositValid = false;
    }

    if (this.validationService.IsinValidPrice(this.offerInputModel.DueDiligencePeriod)) {
      this.dueDiligencePeriodValid = true;
      this.IsValid = false;
    }
    else {
      this.dueDiligencePeriodValid = false;
    }

    if (this.validationService.IsinValidPrice(this.offerInputModel.ClosingPeriod)) {
      this.closingPeriodValid = true;
      this.IsValid = false;
    }
    else {
      this.closingPeriodValid = false;
    }
    if (type == 1) {
      this.checkIfUserInfoValid();


    }
  }

  offerPriceValidation() {
    if (this.validationService.IsinValid(this.offerInputModel.OfferPrice)) {
      this.offerPriceValid = true;
      this.IsValid = false;
      this.offerPriceValidText = "Offer price is required";
    }
    else if (this.validationService.IsinValidPrice(this.offerInputModel.OfferPrice)) {
      this.offerPriceValid = true;
      this.IsValid = false;
      this.offerPriceValidText = "Offer price should be greater than 0";
    }
    else {
      this.offerPriceValid = false;
      this.IsValid = true;
    }
  }

  earnestMoneyDepositValidation() {
    if (this.validationService.IsinValid(this.offerInputModel.EarnestMoneyDeposit)) {
      this.earnestMoneyDepositValid = true;
      this.IsValid = false;
      this.earnestMoneyDepositValidText = "Earnest Money Deposit is required";
    }
    else if (this.validationService.IsinValidPrice(this.offerInputModel.EarnestMoneyDeposit)) {
      this.earnestMoneyDepositValid = true;
      this.IsValid = false;
      this.earnestMoneyDepositValidText = "Earnest Money Deposit should be greater than 0";
    }
    else {
      this.earnestMoneyDepositValid = false;
      this.IsValid = true;
    }
  }

  dueDiligencePeriodValidation() {
    if (this.validationService.IsinValid(this.offerInputModel.DueDiligencePeriod)) {
      this.dueDiligencePeriodValid = true;
      this.IsValid = false;
      this.dueDeligencePeriodValidText = "Due Deligence Period is required";
    }
    else if (this.validationService.IsinValidPrice(this.offerInputModel.DueDiligencePeriod)) {
      this.dueDiligencePeriodValid = true;
      this.IsValid = false;
      this.dueDeligencePeriodValidText = "Due Deligence Period should be greater than 0";
    }
    else {
      this.dueDiligencePeriodValid = false;
    }
  }

  closingPeriodValidation() {
    if (this.validationService.IsinValid(this.offerInputModel.ClosingPeriod)) {
      this.closingPeriodValid = true;
      this.IsValid = false;
      this.closingPeriodValidText = "Closing Period is required";
    }
    else if (this.validationService.IsinValidPrice(this.offerInputModel.ClosingPeriod)) {
      this.closingPeriodValid = true;
      this.IsValid = false;
      this.closingPeriodValidText = "Closing Period should be greater than 0";
    }
    else {
      this.closingPeriodValid = false;
    }
  }

  validateEmail() {
    //if ((this.validationService.isEmail(this.offerInputModel.Email) == false) && !this.validationService.IsinValid(this.offerInputModel.Email)) {
    //    this.emailValid = false;
    //    this.emailvalidation = "invalid Email address";
    //}
    //else {
    //    this.emailValid = true;
    //    this.emailvalidation = "";
    //}
    //if (this.validationService.IsinValid(this.offerInputModel.Email)) {
    //    this.emailValid = false;
    //}


  }

  getPropertyDetail() {
    if (this.isEdit) {
      this.loaderService.display(true);
    }
    this._offerService.getPropertyDetails(this.propertyGuid).subscribe(response => {
      this.propertyDetailForOffer = response;
      if (response != null && this.propertyDetailForOffer.ConfidentialLocation && !this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && !this.authService.DataEntryStaff()) {
        this.haveaccesstoviewlocation = false;
      }
      else {
        this.haveaccesstoviewlocation = true;
      }
      if (this.isPortfolio) {
        this.propertyDetailForOffer.Price = this.askingPrice;
      }

      if (this.propertyDetailForOffer.IsPortfolio && this.isEdit) {
        this.showWizard(1);
      }
      this.loaderService.display(false);
      if (this.propertyDetailForOffer.PrimaryContactPhone != null) {
        this.offerInputModel.BrokerPhone = this.propertyDetailForOffer.PrimaryContactPhone.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2-$3');
      }

      if (this.propertyDetailForOffer.FilePath === undefined || this.propertyDetailForOffer.FilePath === null || this.propertyDetailForOffer.FilePath === "") {
        this.propertyDetailForOffer.FilePath = '/../../../assets/img/default-property_1.png'
      }
      if (this.propertyDetailForOffer.PrimaryContactImagePath === undefined || this.propertyDetailForOffer.PrimaryContactImagePath === null || this.propertyDetailForOffer.PrimaryContactImagePath === "") {
        this.propertyDetailForOffer.PrimaryContactImagePath = '/../../../assets/img/default-profile-img.png'
      }
    })
  }

  getOfferDetailForEdit() {

    this._offerService.getOfferDetailForEdit(this.inputOfferGuid).subscribe(response => {
      this.offerInputModel = response;
      this.offerInputModel.OfferPrice = response.OfferPrice;
      this.offerInputModel.Documents = response.Documents;
      this.offerInputModel.IsGeneratedLOI = response.IsGeneratedLOI;

      this.offerInputModel.EarnestMoneyDeposit = response.EarnestMoneyDeposit;
      this.offerInputModel.ExchangeAmount = this.validationService.commaFormat(response.ExchangeAmount);
      this.offerInputModel.AssetValue = this.validationService.commaFormat(response.AssetValue);
      this.offerInputModel.BuyerPower = this.validationService.commaFormat(response.BuyerPower);
      this.offerInputModel.OfferForExtBroker = this.offerInputModel.OfferForExtBroker == null ? false : this.offerInputModel.OfferForExtBroker;
      if (this.offerInputModel.OfferForExtBroker) {
        this.extBrokerSelected = true;
        //this.offerInputModel.FirstName = response.FirstName;
        //this.offerInputModel.LastName = response.LastName;
        //this.offerInputModel.Email = response.Email;
        //this.offerInputModel.Phone = response.Phone;    
      }

      if (response.ExchangeClosingDate != null) {
        this.offerInputModel.ExchangeClosingDate = this.validationService.convertUTCDateToLocalDate(response.ExchangeClosingDate);
      }

      if (response.Exchange1031Id != 0 && response.Exchange1031Id != null) {
        this.isExchangeDisabled = true;
      }

      this.exchangeCodeInputModel.BuyerId = response.UserId;
      if (!this.offerInputModel.OfferForExtBroker) {
        this.onIs1031ExchangeCheckboxChange(this.offerInputModel.Is1031Exchange);
      }
      if (this.isFromQuickEdit) {
        if (this.offerInputModel.IsGeneratedLOI) {
          this.offerInputModel.uploadType = 'generateloi';
          this.showWizard(11);
        }
        else {
          this.offerInputModel.uploadType = 'uploadmyownloi';
          this.showWizard(1);
        }
      }
      else {
        this.showWizard(0);
      }
    })
  }

  savePlaceOffer(template: TemplateRef<any>, classes: any, isDraft, IsMailNeeded: number = 0) {

    this.offerDetailsValidation();
    if (this.isBrokerView && this.IsValid) {
      this.buyerInformationValidation();
    }
    this.IsSendEmailToBuyer = IsMailNeeded == 2 ? true : false;
    let isNeededPrincipleEmail = true;
    if (this.authService.Admin() || this.authService.SuperAdmin() || this.authService.Broker()) {
      if (this.offerInputModel.CoBrokerId == 0 || (this.offerInputModel.CoBrokerId > 0 && this.offerInputModel.OfferForExtBroker == false)) {
        if (this.isEdit && !isDraft) {
          if (this.IsSeneEmailIsshowed) {
            isNeededPrincipleEmail = true;
          }
          else {
            isNeededPrincipleEmail = false;
          }
         
        }
      }
    }
  

  if(this.IsValid) {
   
      this.IsSeneEmailIsshowed = false;
      this.isSaveDisabled = true;
      this.loaderService.display(true);
      this.offerInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
      this.offerInputModel.LTV = this.validationService.DecimalOnly(this.offerInputModel.LTV);
      this.offerInputModel.InterestRate = this.validationService.DecimalOnly(this.offerInputModel.InterestRate);
      this.offerInputModel.OfferDate = new Date();
      this.offerInputModel.Name = this.offerInputModel.FirstName;

      if (this.isOwnLOI) {
        this.offerInputModel.OwnLOI = true;
      }
      else {
        this.offerInputModel.OwnLOI = false;
      }

      if (isDraft) {
        this.offerInputModel.IsDraft = true;
    }
    if (this.user != null && (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) ||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))) {

        this.offerInputModel.CoBrokerId = this.user.Id;
    }
    else if (!this.authService.IsUserRole(this.authService.UserRole.Admin) && !this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.offerInputModel.CoBrokerId = 0;
      }
      if (this.IsExternalBroker) {
        this.offerInputModel.CoBrokerId = this.user.Id;
      }

      //this._offerService.checkDuplicatePlaceOfferByCoBroker(this.offerInputModel).subscribe(response => {
      //    if (response == false) {

      this.placeOfferApi(isDraft);

    //}
    //else {
    //    this._toastService.addToast({ title: 'Error Occurred', msg: 'Sorry! You cannot submit an offer against this property because, either you or a user associated with ,or you have already submitted an offer and is still under sellers consideration.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    //}
    //});

  }
    else {
  this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
}
  }

placeOfferApi(isDraft) {

  if (this.isPortfolio) {
    this.offerInputModel.IsPortfolio = this.isPortfolio;
    this.offerInputModel.PortfolioPropertyIds = this.propertyList.map(t => t.Id);
    this.offerInputModel.PropertyId = this.inputPropertyId;
  }
  ////this._authService.createUserAndGenerateResetPassword(this.offerInputModel.Email).subscribe(res => {
  ////    this.offerInputModel.UserPasswordResetTicket = res["ticket"];
  this._offerService.savePlaceOffer(this.offerInputModel).subscribe(response => {
    this.resultOutputModel = response;
    if (this.resultOutputModel.Success) {
      if (isDraft) {
        this._toastService.addToast({ title: 'Success', msg: 'Offer Saved to Draft Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      this.latestId = this.resultOutputModel.Id;
      this.BuyerQuestionsOfferId = this.latestId;
      this.BuyerQuestionsPropertyId = this.offerInputModel.PropertyId;
      if (this.selectedFiles != null && this.selectedFiles.length > 0) {
        this.uploadFiles();
      }

      if (this.selectedFilesForLOI && this.selectedFilesForLOI.length > 0) {
        this.inputFileUploadForLOI.documentName = "LOI Document";
        this.inputFileUploadForLOI.fileCategoryId = 413;
        this.inputFileUploadForLOI.id = this.latestId;
        this.inputFileUploadForLOI.objectId = this.latestId;
        this.inputFileUploadForLOI.objectTypeId = 303;
        this.inputFileUploadForLOI.type = "Documents";
        this.inputFileUploadForLOI.uploadType = null;

        this._fileUploadService.uploadFiles(this.inputFileUploadForLOI, this.selectedFilesForLOI).subscribe(response => {
          this._fileUploadService.GetLOIPath(Number(response[0]["UploadedFileId"])).subscribe(res => {
            if (!isDraft) {
              this.uploadedLOIPath = res.toString();
              if (this.resultOutputModel.IsSendEmail) {
                this.principalEmailInputModel.UserId = this.resultOutputModel.UserId;
                this.principalEmailInputModel.PropertyId = this.offerInputModel.PropertyId;
                this.principalEmailInputModel.IsAdd = this.resultOutputModel.IsAddedOffer;
                this.principalEmailInputModel.LeadDetailGuid = this.resultOutputModel.Guid;
                this.principalEmailInputModel.FilePath = this.uploadedLOIPath;
                this.principalEmailInputModel.LoggedInUserId = this.user.Id;
                this.principalEmailInputModel.PreviousLeadDetailId = this.resultOutputModel.PreviousLeadId;
                this._offerService.sendEmailToPrincipal(this.principalEmailInputModel).subscribe(response => {
                });
              }
              this.resultOutputModel.DocumentPath = this.uploadedLOIPath;
              $('html,body').animate({ scrollTop: 300 }, 500);
              this.wizard = 4;
              if (this.propertyDetailForOffer.PrimaryContactName != null) {
                this.submitLOIConfirmationMessage = this.propertyDetailForOffer.PrimaryContactName + " will get in touch with you soon";
              }
              else {
                this.submitLOIConfirmationMessage = "Our Broker will get in touch with you soon";
              }
              if ((this.authService.Broker() || this.authService.Principal() || this.authService.Principal1031() || this.authService.ExternalBroker() || this.authService.Admin() || this.authService.SuperAdmin()) && (this.offerInputModel.Exchange1031Id == null || this.offerInputModel.Exchange1031Id <= 0)) {
                document.getElementById("BuyerQuestinnaire").click();
              }
              this.showPortfolioData.emit();

              this.isSaveDisabled = false;
              this.loaderService.display(false);
            }
            else {
              this.isSaveDisabled = false;
              this.afterSubmit();
              this.loaderService.display(false);
            }
          });
          this.clearFilesForLOI++;
        });
      }
      else {
        if (this.resultOutputModel.IsSendEmail && !isDraft) {
          this.principalEmailInputModel.UserId = this.resultOutputModel.UserId;
          this.principalEmailInputModel.PropertyId = this.offerInputModel.PropertyId;
          this.principalEmailInputModel.IsAdd = this.resultOutputModel.IsAddedOffer;
          this.principalEmailInputModel.LeadDetailGuid = this.resultOutputModel.Guid;
          this.principalEmailInputModel.FilePath = this.resultOutputModel.DocumentPath;
          this.principalEmailInputModel.LoggedInUserId = this.user.Id;
          this.principalEmailInputModel.PreviousLeadDetailId = this.resultOutputModel.PreviousLeadId;

          this._offerService.sendEmailToPrincipal(this.principalEmailInputModel).subscribe(response => {
          });
        }
      }

      if (this.selectedFilesForAdditional != null && this.selectedFilesForAdditional.length > 0) {
        this.uploadFilesAdditional();
      }

      if (this.offerInputModel != null && ((this.offerInputModel.CoBrokerId != null && this.offerInputModel.CoBrokerId > 0 || this.offerInputModel.UserId != null && this.offerInputModel.UserId > 0))) {

        this._offerService.savePlaceOfferToUserFlowLog(this.offerInputModel).subscribe(response => { });
      }

      if (!(this.selectedFilesForLOI && this.selectedFilesForLOI.length > 0)) {
        if (!isDraft) {
          $('html,body').animate({ scrollTop: 300 }, 500);
          this.wizard = 4;
          if ((this.authService.Broker() || this.authService.Principal() || this.authService.Principal1031() || this.authService.ExternalBroker() || this.authService.Admin() || this.authService.SuperAdmin()) && (this.offerInputModel.Exchange1031Id == null || this.offerInputModel.Exchange1031Id <= 0)) {
            document.getElementById("BuyerQuestinnaire").click();
          }
          this.isSaveDisabled = false;
          this.loaderService.display(false);
        }
        else {
          this.isSaveDisabled = false;
          setTimeout(() => {
            this.afterSubmit();
            this.loaderService.display(false);
          }, 5000);
        }
      }
    }
    else {
      this.loaderService.display(false);
      this.isSaveDisabled = false;
      this._toastService.addToast({ title: 'Error Occurred', msg: this.resultOutputModel.ReturnMsg, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }

    if (this.modalRef != undefined && this.modalRef != null) {
      this.modalRef.hide();
    }

    window.scrollTo(0, 0);
    //})
  });
}

downloadLOITemplateToPDF() {
  this.loaderService.display(true);
  this.offerInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
  this.offerInputModel.LTV = this.validationService.DecimalOnly(this.offerInputModel.LTV);
  this.offerInputModel.InterestRate = this.validationService.DecimalOnly(this.offerInputModel.InterestRate);
  this.offerInputModel.OfferDate = new Date();

  this._offerService.downloadLOITemplateToPDF(this.offerInputModel).subscribe(response => {

    this.downloadLOIPath = response;
    window.open(this.downloadLOIPath, '_blank');
    this.loaderService.display(false);
  });
}

afterSubmit() {
  this.disblesubmitofferbutton = false;
  if (this.IsFromPropertyView) {
    location.reload();
    //this.router.navigateByUrl("redirect?url=" + this.router.url);
    // this.modalRef.hide();
  }
  else if (this.fromPage == "PropertyView") {
    this.router.navigate(['/viewproperty/' + this.propertyGuid]);
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
  else if (this.fromPage == "MyOffers") {
    this.router.navigate(['/my-property-view']);
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
  else if (this.fromPage == "BrokerOfferList") {
    this.router.navigate(['/offers-list']);
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
  else if (this.fromPage.includes("dashboard-1031")) {
    this.router.navigateByUrl(this.fromPage + "?tab=offers");
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
  else {
    this.router.navigateByUrl(this.fromPage);
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
}



onViewProperty() {
  this.router.navigate(['/viewproperty/' + this.propertyGuid]);
}

onMyOffers() {
  this.router.navigate(['/my-property-view']);
}

onBuyerSelect($event) {
  if ($event.originalObject) {

    this.offerInputModel.UserId = $event.originalObject.Id;
    this.offerInputModel.Name = $event.originalObject.FirstName;
    this.offerInputModel.FirstName = $event.originalObject.FirstName;
    this.offerInputModel.LastName = $event.originalObject.LastName;
    this.offerInputModel.Email = $event.originalObject.Email;
    this.offerInputModel.Phone = $event.originalObject.Phone;
    this.offerInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
    this.offerInputModel.CompanyName = $event.originalObject.CompanyName;
    this.exchangeCodeInputModel.BuyerId = $event.originalObject.Id;
    this.exchangeCodeInputModel.IsEdit = (this.isFromQuickEdit || this.isEdit) ? true : false;
    this._offerService.checkDuplicatePlaceOfferByCoBroker(this.offerInputModel).subscribe(response => {
      if (response) {
        this.offerInputModel.UserId = null;
        this.offerInputModel.Name = null;
        this.offerInputModel.FirstName = null;
        this.offerInputModel.LastName = null;
        this.offerInputModel.Email = null;
        this.offerInputModel.Phone = '';
        this.offerInputModel.CompanyName = null;
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Sorry! You cannot submit an offer against this property because, either you or a user associated with ,or you have already submitted an offer and is still under sellers consideration.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.trade1031Service.GetExchangeCodeByBuyerAndBroker(this.exchangeCodeInputModel).subscribe(res => {

          this.exchangeCodes = res;
          if (this.exchangeCodes.length > 0) {

            this.offerInputModel.Is1031Exchange = true;
            this.isNormalPrincipalView = false;
            this.onIs1031ExchangeCheckboxChange(true);
          }
          else {
            this.offerInputModel.Is1031Exchange = false;
            this.offerInputModel.Exchange1031Id = 0;
            this.offerInputModel.ExchangeAmount = null;
            this.offerInputModel.ExchangeClosingDate = null;
          }

        });
      }
    });


  }
}

openModalShareWithOhters(template: TemplateRef < any >, classes: any) {
  this.offerDetailsValidation();
  if (this.IsValid) {
    this.mailIds = [];
    this.keyCode = [32, 188, 13];
    this.offerInputModel.ShareMailIds = [];
    this.modalRefShareWithOthers = this.modalService.show(template, { class: classes });
  }
  else {
    this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill in the mandatory fields in the correct format', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
  }

}

validEmail$(control: any) {

  if (control.value != "") {
    let serchfind: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    serchfind = regexp.test(control.value);
    if (serchfind == false) {
      return {
        'validEmail$': true
      };
    }
  }

  return null;
}

  public validators = [this.validEmail$];

  public errorMessages = {
  'validEmail$': 'Invalid Email Address'
};
isOwnLOI = false;
shareLOIToOtherMails() {
  this.disabledShareBtn = true;
  if (this.mailIds.length > 0) {
    this.loaderService.display(true);
    this.mailIds.forEach(x => {
      this.offerInputModel.ShareMailIds.push(x.value)
    });
    this.offerInputModel.PropertyId = this.propertyDetailForOffer.PropertyId;
    this.offerInputModel.LTV = this.validationService.DecimalOnly(this.offerInputModel.LTV);
    this.offerInputModel.InterestRate = this.validationService.DecimalOnly(this.offerInputModel.InterestRate);
    this.offerInputModel.OfferDate = new Date();
    this.offerInputModel.OwnLOI = false;
    if (this.isOwnLOI) {
      this.offerInputModel.OwnLOI = true;
      this.inputFileUploadForLOI.documentName = "LOI Document";
      this.inputFileUploadForLOI.fileCategoryId = 413;
      this.inputFileUploadForLOI.id = this.latestId;
      this.inputFileUploadForLOI.objectId = this.latestId;
      this.inputFileUploadForLOI.objectTypeId = 303;
      this.inputFileUploadForLOI.type = "Documents";
      this.inputFileUploadForLOI.uploadType = "LOI";
      this._fileUploadService.uploadFiles(this.inputFileUploadForLOI, this.selectedFilesForLOI).subscribe(response => {
        this.offerInputModel.OwnLOIPath = response[0]["AmazonPath"].toString()
        this._offerService.shareLOIToOtherMails(this.offerInputModel).subscribe(response => {
          this.loaderService.display(false);
          this._toastService.addToast({ title: 'Success', msg: 'Shared Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.modalRefShareWithOthers.hide();
          this.disabledShareBtn = false;
        });
      });
    }
    else {
      this._offerService.shareLOIToOtherMails(this.offerInputModel).subscribe(response => {
        this.loaderService.display(false);
        this._toastService.addToast({ title: 'Success', msg: 'Shared Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.modalRefShareWithOthers.hide();
        this.disabledShareBtn = false;
      });
    }
  }
  else {
    this.disabledShareBtn = false;
    this._toastService.addToast({ title: 'Error Occurred', msg: 'Please enter at least one email address', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
  }
}
selectedExchange(selectedExchange: Iexchange) {
  this.selectExchange = "Change Exchange";
  this.disableTextBox = "true";
  this.offerInputModel.UserId = selectedExchange.userId
  this.offerInputModel.Exchange1031Id = selectedExchange.exId;
  this.offerInputModel.Name = selectedExchange.firstName;
  this.offerInputModel.FirstName = selectedExchange.firstName;
  this.offerInputModel.LastName = selectedExchange.lastName;
  this.offerInputModel.Email = selectedExchange.email;
  this.offerInputModel.Phone = selectedExchange.phone;
  this.offerInputModel.CompanyName = selectedExchange.company;

}


ClearExchange() {
  this.selectExchange = "Select Exchange";
  this.disableTextBox = "false";
  this.offerInputModel.UserId = 0;
  this.offerInputModel.Exchange1031Id = 0;
  this.offerInputModel.Name = null;
  this.offerInputModel.FirstName = null;
  this.offerInputModel.LastName = null;
  this.offerInputModel.Email = null;
  this.offerInputModel.Phone = '';
  this.offerInputModel.CompanyName = null;
  $("#txtPhone").prop("disabled", false);
}

onExternalBrokerPlaceOffer() {
  if (!this.offerInputModel.OfferForExtBroker) {
    this.offerInputModel.BuyerFirstName = null;
    this.offerInputModel.BuyerLastName = null;
    this.offerInputModel.BuyerEmail = null;
    this.offerInputModel.BuyerPhone = '';

    if ((this.authService.Broker() || this.authService.Admin() || this.authService.SuperAdmin()) && !this.offerInputModel.Is1031Exchange) {
      this.offerInputModel.Email = null;
      this.offerInputModel.FirstName = null;
      this.offerInputModel.LastName = null;
      this.offerInputModel.Phone = '';
    }

  }
  else {
    this.offerInputModel.Is1031Exchange = false;
    this.onIs1031ExchangeCheckboxChange(this.offerInputModel.Is1031Exchange);
  }
}
extBrokerSelected = false;
onUserSelect(user: IMatchingUsers) {
  this.extBrokerSelected = true;
  this.brokerSelectedFromSlider = false;
  this.offerInputModel.UserId = user.UserId;
  this.offerInputModel.FirstName = user.FirstName;
  this.offerInputModel.LastName = user.LastName;
  this.offerInputModel.Email = user.Email;
  this.offerInputModel.Phone = user.Phone;
  this.offerInputModel.CompanyName = user.Company;
  this.modalRefMatching.hide();
}

resetExBrokerSelection() {
  this.extBrokerSelected = false;
}

getBuyerNameIfAny() {
  let buyerInfo = "";
  if (this.offerInputModel.OfferForExtBroker) {
    if (!this.validationService.IsinValid(this.offerInputModel.BuyerFirstName)) {
      buyerInfo += this.offerInputModel.BuyerFirstName + " ";
    }
    if (!this.validationService.IsinValid(this.offerInputModel.BuyerLastName)) {
      buyerInfo += this.offerInputModel.BuyerLastName;
    }
    if (!this.validationService.IsinValid(buyerInfo)) {
      return 'on behalf of ' + buyerInfo;
    }
  }
  return buyerInfo;
}
selectBroker = "Search Broker";
brokerSelectedFromSlider = false;
selectedUser(user: any) {
  this.selectBroker = "Search Broker";
  this.brokerSelectedFromSlider = true;
  this.extBrokerSelected = true;
  this.offerInputModel.UserId = user.Id;
  this.offerInputModel.FirstName = user.FirstName;
  this.offerInputModel.LastName = user.LastName;
  this.offerInputModel.Email = user.Email;
  this.offerInputModel.Phone = user.Phone;
  this.offerInputModel.CompanyName = user.Company;
}
clearBrokerSelectedFromSlider() {
  this.selectBroker = "Search Broker";
  this.extBrokerSelected = false;
  this.clearUserData();
  this.brokerSelectedFromSlider = false;
}

checkDuplicateUser() {
  if ((this.validationService.isEmail(this.offerInputModel.Email) == true) && !this.validationService.IsinValid(this.offerInputModel.Email)) {
    this._offerService.checkDuplicateUser(this.offerInputModel).subscribe(response => {
      if (response != null) {
        this.duplicateUserFound = true;
        this.offerInputModel.SendInvitationMail = false;
        this.offerInputModel.FirstName = response.FirstName;
        this.offerInputModel.LastName = response.LastName;
        this.offerInputModel.Phone = response == null ? '' : response.Phone;;
        this.offerInputModel.CompanyName = response.CompanyName;
        this.offerInputModel.BuyerEntity = response.BuyerEntity;
        this.offerInputModel.UserId = response.UserId;
        this.buyerInformationValidation();
      }
      else {
        this.offerInputModel.UserId = 0;
        this.offerInputModel.FirstName = null;
        this.offerInputModel.LastName = null;
        this.offerInputModel.Phone = response == null ? '' : response.Phone;;
        this.offerInputModel.CompanyName = null;
        this.offerInputModel.BuyerEntity = null;
        this.duplicateUserFound = false;
        this.offerInputModel.SendInvitationMail = true;
        this.IsValid = true;
      }
    });
  }
}
CancelPlaceOfferPopup() {
  this.modalRef.hide();
  this.disblesubmitofferbutton = false;
}

previews(template: TemplateRef < any >, classes, document) {
  this.docPreview = document;
  this.documentPreview = this.modalService.show(template, { class: classes });
}

openBuyerModal(template: TemplateRef < any >, classes: any) {
  this.closeModal();
  this.modalBuyerRef = this.modalService.show(template, { class: classes });
};

closeModal() {
  this.close.emit();
}

checkExistingUser() {
  if (this.user != null && (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031))) {
    this.duplicateUserFound = true;
    this.offerInputModel.SendInvitationMail = false;
  }
  else {
    if (this.offerInputModel.Email != null && this.offerInputModel.Email != '' && this.offerInputModel.Email != '') {
      this._offerService.checkDuplicateUser(this.offerInputModel).subscribe(response => {
        if (response != null) {
          this.duplicateUserFound = true;
          this.offerInputModel.SendInvitationMail = false;
        }
        else {
          this.duplicateUserFound = false;
          this.offerInputModel.SendInvitationMail = true;
        }
      });
    }
    else {
      this.duplicateUserFound = true;
      this.offerInputModel.SendInvitationMail = false;
    }
  }
}

sendEmailModal() {
  this.modalRefSendEmail = this.modalService.show(this.sendEmail, { class: 'deletemodal' });
  this.IsSeneEmailIsshowed = true;
}
}
